if (!customElements.get("announcement-bar")) {
  class t extends HTMLElement {
    connectedCallback() {
      (this.announcement = this.querySelector(".announcement")),
        (this.backgrounds = this.querySelectorAll(".announcement-bg"));
      let t = new MutationObserver(this.mutationCallback.bind(this)),
        e = { attributes: !0, attributeFilter: ["class"] };
      this.querySelectorAll(".slideshow__slide").forEach((n) => {
        t.observe(n, e);
      });
    }
    mutationCallback(t) {
      for (let e of t)
        "attributes" === e.type &&
          e.target.classList.contains("is-active") &&
          this.setActiveSlide(e.target);
    }
    setActiveSlide(t) {
      this.announcement.style.setProperty(
        "--announcement-text-color",
        t.dataset.textColor
      ),
        this.backgrounds.forEach((e) => {
          e.classList.toggle("is-active", e.dataset.index === t.dataset.index);
        });
    }
  }
  customElements.define("announcement-bar", t);
}
